import shortUUID from "short-uuid";
import { PopinaItemInterface } from "../controller/model/popina/interface";
import PopinaRestaurant from "../controller/model/popina/PopinaRestaurant";
const uuidTranslator = shortUUID();

export const shortenUUID = (uuid: string = "") => {
  return uuidTranslator.fromUUID(uuid);
};

const mapSkus = (
  prices: any[] = [],
  optionCategoriesIds: string[] = [],
  priceTypes: any,
  skuProductRef: string
) => {
  const formatedPrices = prices.reduce((accu: any, i: any) => {
    if (i.amount >= 0) {
      accu.push(i)
    }
    return accu;
  }, [])
  const priceOverrides = formatedPrices
    ?.filter((price: any) => price.price_type !== 0)
    .map((p: any) => {
      const serviceTypeRefs = [];
      const priceType = priceTypes.find(
        (pt: any) => pt.price_type === p.price_type
      );
      if (priceType?.name) serviceTypeRefs.push(priceType?.name);
      const priceOvveride: any = {
        price: `${(p.amount / 100).toFixed(2)} EUR`
      };
      if (serviceTypeRefs.length > 0)
        priceOvveride.service_type_refs = serviceTypeRefs;
      return priceOvveride;
    });
  const normalPrice: any = formatedPrices.find((price: any) => price.price_type === 0);
  return [{
    ref: skuProductRef,
    name: normalPrice?.name ?? null,
    price: `${((normalPrice?.amount >= 0 ? normalPrice?.amount : 200) / 100).toFixed(2)} EUR`,
    option_list_refs: optionCategoriesIds
      .map((optionId: any) => shortenUUID(optionId))
      .filter(
        (opt: string, index: number, arr: string[]) =>
          index === arr.lastIndexOf(opt)
      ),
    price_overrides: priceOverrides
  }];
};

const mapProducts = (
  items: PopinaItemInterface[] = [],
  priceTypes: any[] = [],
  optionCategories: any[] = []
) => {
  const formatedItems = items.reduce((accu: any[], i: any) => {
    if (i.name !== "") {
      accu.push(i)
    }
    return accu;
  }, [])

  return formatedItems
    ?.map((item: PopinaItemInterface) => {
      const skuProductRef = shortenUUID(item.client_id)
      const optionCategoriesIds = [
        ...item.sharedOptionCategories,
        ...item.optionCategories
      ].filter((optId: any) =>
        optionCategories.find(opt => opt.client_id === optId)
      );
      return {
        ref: skuProductRef,
        category_ref: shortenUUID(item?.categoryID),
        name: item?.name ? item.name : null,
        skus: mapSkus(item?.prices, optionCategoriesIds, priceTypes, skuProductRef)
      };
    })
    .filter((i: any) => !!i.name);
};

const mapCategories = (categories: any = []) => {
  return categories?.map((category: any) => ({
    ref: shortenUUID(category.client_id),
    name: category.name ?? null
  }));
};

const mapDiscounts = (discounts: any = []) => {

  const formatedDiscounts = discounts.reduce((accu: any[], i: any) => {
    if (i.name !== "" && i.amount >= 0) {
      accu.push(i)
    }
    return accu;
  }, [])
  return formatedDiscounts?.map((discount: any) => ({
    ref: shortenUUID(discount.client_id),
    name: discount.name,
    pricing_effect:
      discount.discount_type === 0 ? "price_off" : "percentage_off",
    pricing_value:
      discount.discount_type === 0
        ? `${(discount.amount / 100).toFixed(2)} EUR`
        : `${discount.amount / 100}`
  }));
};

const mapOptionList = (optionCategories: any = []) => {
  const formatedOptionList = optionCategories.reduce((accu: any[], i: any) => {
    if (i.name !== "" && i.options.filter((positivePrice: any) => positivePrice.price >= 0)) {
      accu.push(i)
    }
    return accu;
  }, [])
  return formatedOptionList
    ?.map((sharedOption: any) => ({
      ref: shortenUUID(sharedOption.client_id),
      name: sharedOption.name,
      options: sharedOption.options
        .map((opt: any) => ({
          ref: shortenUUID(opt.client_id),
          name: opt.name,
          price: `${(opt.price / 100).toFixed(2)} EUR`
        }))
        .filter((i: any) => !!i.name)
    }))
    .filter((optList: any) => optList?.options?.length > 0);
};

const mapDeals = (menus: any = [], items: any = []) => {
  const formatedDeals = menus.reduce((accu: any[], i: any) => {
    if (i.name !== "" && i.steps.name !== "") {
      accu.push(i)
    }
    return accu;
  }, [])
  return formatedDeals.map((menu: any) => ({
    ref: shortenUUID(menu.client_id),
    name: menu.name ?? "menu",
    lines: menu.steps.map((step: any) => ({
      label: step.name,
      skus: step.positions
        .map((position: any) => {
          const item = items.find(
            (item: any) => item.client_id === position.client_id
          );
          item.prices.find(
            (price: any) => price.price_type === 0
          );
          return item.client_id
            ? { ref: shortenUUID(item.client_id) }
            : false;
        })
        .filter((sku: any) => !!sku),
      pricing_effect: "price_off",
      pricing_value: step.amount_to_substract >= 0 ? `${((step?.amount_to_substract || 0) / 100).toFixed(
        2
      )} EUR` : '0'
    }))
  }));
};

export const formatRestaurantCardToCatalog = (
  restaurantCard: PopinaRestaurant
) => {
  const optionCategories = restaurantCard?.getAllOptionCategories
    ? restaurantCard.getAllOptionCategories()
    : [];

    const products = mapProducts(
    restaurantCard?.items.filter((product) => product.name !== "" && product.prices.map((item: any) => item.amount >= 0)),
    restaurantCard?.priceTypes,
    optionCategories
  );

  const categories = mapCategories(restaurantCard.category.filter((category) => category.name !== ""));

  const discounts = mapDiscounts(restaurantCard.discounts.filter((discount) => discount.name !== "" && discount.amount >= 0));

  const option_lists = mapOptionList(optionCategories.filter((option) => option.name !== ""));

  const deals = mapDeals(restaurantCard?.menus, restaurantCard?.items.filter((item: any) => item.name !== "" && item.prices.map((product: any) => product.amount >= 0)));

  return {
    products,
    categories,
    discounts,
    option_lists,
    deals
  };
};
